import React, { useEffect } from 'react';
import CallToAction from '../components/Misc/CallToAction';
import Heading from '../components/Headers/Heading';
import ProjectsContent from '../components/ProjectComponents/ProjectsContent';
import Seo from '../components/Misc/Seo';

import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function OurWork() {
    const canonical = 'https://studio.norcat.org/OurWork';
    const title = 'Our Work | A Studio driven by experiences that matter.';
    const description = 'Explore Studio NORCAT projects across VR, AR, simulation, software, and interactive installations built to support learning, training, and engagement.';

    useEffect(() => {
        document.body.classList.add('our-work-page-view');

        return () => {
            document.body.classList.remove('our-work-page-view');
        };
    }, []);

    return (
        <div className="our-work-page">
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                twitterTitle={title}
                twitterDescription={description}
            />
            <Heading
                heading={<h1>Our Work</h1>}
                headingClass="heading-very-large dark-1"
                paragraph="Our solutions are used by teams worldwide to support safer, more effective, and more engaging learning."
                paragraphClass="dark-2"
                WrapperComponent={(props) => {
                    return (
                        <div className="page-header">
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        </div>
                    );
                }}
            />
            <div className="projects">
                <div className="projects-wrapper">
                    <ProjectsContent load="true" />
                </div>
            </div>
            {/*<Testimonial type="5" />*/}
            <CallToAction
                wrapperClass="bg-main"
                heading={
                    <span style={{ color: '#fff' }}>
                        Have an idea?
                        <br />
                        Let's explore it together.
                    </span>
                }
                buttonText="Contact Us"
                buttonLink="/Contact"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
        </div>
    );
}

export default OurWork;
